import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus controller for the badge showcase panel.
 * Handles badge detail modal and category filtering.
 */
export default class extends Controller {
  static targets = ["modal", "modalIcon", "modalTitle", "modalDescription", "modalMeta"]

  static values = {
    badgeData: Object
  }

  connect() {
    // Pre-load badge data from the DOM
    this.badges = this.collectBadgeData()
  }

  collectBadgeData() {
    const badges = {}
    this.element.querySelectorAll("[data-badge-key]").forEach(el => {
      badges[el.dataset.badgeKey] = {
        key: el.dataset.badgeKey,
        tier: el.dataset.tier,
        title: el.querySelector(".badge-showcase__badge-label")?.textContent?.trim(),
        earned: el.classList.contains("badge-showcase__badge--earned"),
        isNew: el.classList.contains("badge-showcase__badge--new"),
        hint: el.getAttribute("title")
      }
    })
    return badges
  }

  showDetail(event) {
    const badgeKey = event.currentTarget.dataset.badgeKey
    const badge = this.badges[badgeKey]

    if (!badge) return

    // Populate modal
    this.modalTitleTarget.textContent = badge.earned ? badge.title : "Conquista Bloqueada"
    this.modalDescriptionTarget.textContent = badge.earned
      ? `Você desbloqueou esta conquista ${badge.tier}!`
      : badge.hint

    // Update icon styling based on tier
    this.modalIconTarget.className = `badge-detail-modal__icon badge-detail-modal__icon--${badge.tier}`
    this.modalIconTarget.innerHTML = badge.earned
      ? '<span class="text-3xl">🏆</span>'
      : '<span class="text-3xl">🔒</span>'

    // Meta info
    this.modalMetaTarget.innerHTML = badge.earned
      ? `<span class="badge-detail-modal__tier badge-detail-modal__tier--${badge.tier}">${this.tierLabel(badge.tier)}</span>`
      : '<span class="text-gray-500 text-sm">Continue explorando para desbloquear</span>'

    // Show modal
    this.modalTarget.showModal()
  }

  closeDetail() {
    this.modalTarget.close()
  }

  tierLabel(tier) {
    const labels = {
      bronze: "Bronze",
      silver: "Prata",
      gold: "Ouro",
      platinum: "Platina"
    }
    return labels[tier] || tier
  }

  // Handle click outside modal
  modalTarget_click(event) {
    if (event.target === this.modalTarget) {
      this.closeDetail()
    }
  }
}
